export default "__VITE_ASSET__DW0TO53S__"